export default __webpack_public_path__ + "static/media/link.bd1beedc.svg";